export const errorHandler = (error) => {
  if (error === 'Login token is not valid anymore') {
    console.log('expired');
    localStorage.removeItem('token');
    window.location.reload();
    return;
  }
};
